import { useMemo, useRef } from "react";
import { useIntlFormatterLocales } from "./useIntlFormatterLocales";

export const defaultOptions: Intl.DateTimeFormatOptions = {
  dateStyle: "long",
} as const;

export function useIntlInstance(
  options: Intl.DateTimeFormatOptions = defaultOptions
): Intl.DateTimeFormat {
  const defaultLocales = useIntlFormatterLocales();
  const optionsRef = useRef(options);
  return useMemo(
    () => new Intl.DateTimeFormat(defaultLocales, optionsRef.current),
    [defaultLocales]
  );
}
